import React from 'react';
import { ColumnFilterContentProps, ValueExpressionDataTableColumnMeta } from '@data-table/data-table.types';
import { PercentBasedValueExpressionFilterContent } from './percent-based-value-expression-filter-content';

import { TimeBasedValueExpressionFilterContent } from './time-based-value-expression-filter-content';
import DecimalValueExpressionFilterContent from '@data-table/components/data-table-column-filter/filter-content/value-expression-filter-content/decimal-value-expression-filter-content/decimal-value-expression-filter-content';
import IntegerValueExpressionFilterContent from '@data-table/components/data-table-column-filter/filter-content/value-expression-filter-content/integer-value-expression-filter-content/integer-value-expression-filter-content';

const ValueExpressionFilterContent = <T, V>({ column, ...rest }: ColumnFilterContentProps<T, V>) => {
  const valueExpression = (column?.columnDef?.meta as ValueExpressionDataTableColumnMeta)?.valueExpression;
  const isTimeBasedValueExpression = (!!valueExpression && valueExpression?.getValueFormat()?.endsWith(' h')) ?? false;
  const isPercentBasedValueExpression =
    (!!valueExpression && valueExpression?.getValueFormat()?.endsWith('%')) ?? false;
  const isDecimalValueExpression =
    (!!valueExpression &&
      !isPercentBasedValueExpression &&
      !isTimeBasedValueExpression &&
      valueExpression.decimalPlaces !== 0) ??
    false;

  if (isTimeBasedValueExpression) {
    return <TimeBasedValueExpressionFilterContent<T, V> column={column} {...rest} />;
  } else if (isPercentBasedValueExpression) {
    return (
      <PercentBasedValueExpressionFilterContent<T, V>
        column={column}
        decimalPlaces={valueExpression?.decimalPlaces}
        {...rest}
      />
    );
  } else if (isDecimalValueExpression) {
    return (
      <DecimalValueExpressionFilterContent<T, V>
        valueQuotient={valueExpression.valueQuotient}
        column={column}
        decimalPlaces={valueExpression?.decimalPlaces}
        {...rest}
      />
    );
  }
  return <IntegerValueExpressionFilterContent<T, V> column={column} {...rest} />;
};

export default ValueExpressionFilterContent;
